<script lang="ts" setup>
import { SancareToggle } from '@sancare/typescript-commons'
import { onMounted } from 'vue'

import { useStore } from '@/store'

withDefaults(defineProps<{
  params: {
    pageSize: number
    showSeen: boolean
  }
  errorMessage?: string | null
}>(), {
  errorMessage: null
})

const store = useStore()

const STAYS_PER_PAGE_OPTIONS = [10, 20, 30, 50, 80, 100, 150]

const emit = defineEmits<{
  (e: 'set-stay-list-parameter', name: string, value: boolean | number)
}>()

onMounted(() => {
  store.commit('resetStaySelection')
})
</script>

<template>
  <div class="ps-1 pe-3">
    <div class="row justify-content-between">
      <div class="col d-flex justify-content-start align-items-md-center ps-2">
        <div
          class="btn-group ps-1"
        >
          <slot />
        </div>
      </div>
      <div class="col d-flex justify-content-end align-items-center border-info">
        <sancare-toggle
          class="me-3"
          label="Afficher les séjours vus"
          :value="params.showSeen"
          @toggle-change="emit('set-stay-list-parameter', 'showSeen', !params.showSeen)"
        />
        <div class="col-auto d-flex align-items-center">
          <div class="flex-shrink-0 me-2">
            Résultats par page
          </div>
          <select
            :value="params.pageSize"
            class="form-select form-select-sm"
            @change="e => emit('set-stay-list-parameter', 'pageSize', Number((e.target as HTMLSelectElement).value))"
          >
            <option
              v-for="option in STAYS_PER_PAGE_OPTIONS"
              :key="option"
              :value="option"
            >
              {{ option }}
            </option>
          </select>
        </div>
      </div>
    </div>
  </div>
  <div
    v-if="errorMessage"
    class="row error-block mt-2 ps-3"
  >
    {{ errorMessage }}
  </div>
</template>

<style lang="scss">
.btn-fixed-width {
  min-width: 80px;
  display: flex;
  justify-content: center;
}
</style>
